import React, { useState, useEffect } from 'react'
import { Image } from 'react-bootstrap'
import Select from 'react-select'

import {
  LANGUAGE_OPTIONS,
  getDefaultLanguageCode,
} from '@/config/languages.constants'
import i18n from '@/components/UI/Internationalisation/i18n'
import langImg from '@/assets/images/lang.svg'
import downarrowblk from '@/assets/images/dropdown-blue-carets.svg'
import './styles.scss'

const LanguageSelect = (props: any) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    getDefaultLanguageCode(),
  )

  useEffect(() => {
    const defaultLang: string = props.default || getDefaultLanguageCode()
    setSelectedLanguage(defaultLang)
    return () => {}
  }, [props.default])

  return (
    <div className="lang-option d-flex">
      <Image src={langImg} />
      <Select
        className="select-sort select-target select-blue shadow-none radius-2 border-0"
        classNamePrefix="select-target-prefix"
        isSearchable={false}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: () => (
            <img src={downarrowblk} alt="dropdown arrow" />
          ),
        }}
        placeholder="Change Language"
        options={LANGUAGE_OPTIONS}
        onChange={(e: any) => {
          i18n.changeLanguage(e.value)
          setSelectedLanguage(e.value)
          props.setSelectedLanguageCode(e.value)
          localStorage.setItem('selectedLanguageCode', e.value)
        }}
        value={LANGUAGE_OPTIONS.find(
          option => option.value === selectedLanguage,
        )}
      />
    </div>
  )
}

export default LanguageSelect
